import { t } from 'i18next';

export const ActRejectionItemGridPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t("documents.actRejection.actRejectionItemsPositionTabTitle"),
        mnemocode: 'act_rejection_creator_plugin',
        permission: 'RejectionAct',
        columns: [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'IdGlobal',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'goodsName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.goodsName'),
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'producerName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.producerName'),
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'seriesNumber',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.seriesNumber'),
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'quantityRem',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.quantityRem'),
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'supplierName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.supplierName'),
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'invoiceNum',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.invoiceNum'),
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'falsificatDocNum',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.falsificatDocNum'),
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'falsificatDocDate',
                propertyType: 'datetime',
                displayName: t('documents.actRejection.fields.falsificatDocDate'),
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'falsificatReasons',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.falsificatReasons'),
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'falsificatLabName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.falsificatLabName'),
                visibility: true,
                width: 300
            }
        ]
    }
}
